import { createAuthClient } from "better-auth/react";

/**
 * Better Auth React client. Same-origin: it talks to /api/auth/* on the same
 * host that serves the SPA (CloudFront routes /api/* to the API instance).
 */
export const authClient = createAuthClient();

export const { useSession, signIn, signOut } = authClient;

export function signInWithGoogle(): void {
  void authClient.signIn.social({ provider: "google", callbackURL: "/" });
}
